import { getTenantByName } from "../AlmeTenantSelector/AlmeTenants";
export function getTenantName(element) {
    const prodKey = element.productType.toUpperCase();
    if (prodKey === "INSTALLMENT_LOAN" ||
        prodKey === "INSTALLMENT_LOAN_PAY_IN_FOUR") {
        return getTenantByName("bnpl");
    }
    else if (prodKey === "INSTALLMENT_LOAN_MONTHLY") {
        return getTenantByName("BNPLMonthlyLoan");
    }
    else if (element.clientId.toLowerCase() === "paysol" && element.cardName.toLowerCase().includes("carecredit")) {
        return getTenantByName("carecredit");
    }
    else if (element.clientId.toLowerCase() === "paysol") {
        return getTenantByName("pscc");
    }
    else {
        return getTenantByName(element === null || element === void 0 ? void 0 : element.clientId);
    }
}
